{
  "FILTER": {
    "AI_PROMPT": "AI Filtr",
    "TITLE": "Filtrovať konverzácie",
    "SUBTITLE": "Pridajte filtre nižšie a kliknite na 'Použiť filtre' pre sprehľadnenie chatov.",
    "EDIT_CUSTOM_FILTER": "Upraviť zložku",
    "CUSTOM_VIEWS_SUBTITLE": "Pridajte alebo odstráňte filtre a aktualizujte svoju zložku.",
    "ADD_NEW_FILTER": "Pridať filter",
    "FILTER_DELETE_ERROR": "Jejda, vyzerá to, že nemôžeme uložiť nič! Pridajte prosím aspoň jeden filter na uloženie.",
    "SUBMIT_BUTTON_LABEL": "Použiť filtre",
    "UPDATE_BUTTON_LABEL": "Aktualizovať zložku",
    "CANCEL_BUTTON_LABEL": "Zrušiť",
    "CLEAR_BUTTON_LABEL": "Vymazať filtre",
    "FOLDER_LABEL": "Názov zložky",
    "TEAMS_LABEL": "Sdílet s",
    "PARENT_FOLDER_LABEL": "Nadrazená složka",
    "NO_PARENT_FOLDER": "Žiadna nadrazená složka",
    "COLOR_LABEL": "Farba",
    "BACKGROUND_COLOR_LABEL": "Farba pozadí",
    "SELECT_COLOR": "Vybrať farbu",
    "CLEAR_SELECTION": "Vymazat výber",
    "SORT_BY_LABEL": "Seradit",
    "FOLDER_QUERY_LABEL": "Dopyt zložky",
    "EMPTY_VALUE_ERROR": "Hodnota je povinná.",
    "TOOLTIP_LABEL": "Filtrovať konverzácie",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "AND",
      "OR": "OR"
    },
    "INPUT_PLACEHOLDER": "Zadajte hodnotu",
    "OPERATOR_LABELS": {
      "present": "Prítomná",
      "not_present": "Nie je prítomná",
      "present_with_answer": "Prítomná s odpoveďou",
      "present_without_answer": "Prítomná bez odpovede",
      "equal_to": "Rovná sa",
      "not_equal_to": "Nerovná sa",
      "does_not_contain": "Neobsahuje",
      "is_present": "Je prítomné",
      "is_not_present": "Nie je prítomné",
      "is_greater_than": "Je väčšie ako",
      "is_less_than": "Je menšie ako",
      "is_greater_than_or_equal": "Je vetší alebo rovno",
      "is_less_than_or_equal": "Je menší alebo rovno",
      "newer_than_days": "Je novejší než x dní (vrátane)",
      "older_than_days": "Je starší než x dní (vrátane)",
      "starts_with": "Začína na",
      "equalTo": "Rovná sa",
      "notEqualTo": "Nerovná sa",
      "contains": "Obsahuje",
      "doesNotContain": "Neobsahuje",
      "isPresent": "Je prítomné",
      "isNotPresent": "Nie je prítomné",
      "isGreaterThan": "Je väčšie ako",
      "isLessThan": "Je menšie ako",
      "isGreaterThanOrEqual": "Je vetší alebo rovno",
      "isLessThanOrEqual": "Je menší alebo rovno",
      "startsWith": "Začína na"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "Pravda",
      "FALSE": "Nepravda"
    },
    "ATTRIBUTES": {
      "STATUS": "Stav",
      "ASSIGNEE_NAME": "Meno pridelencu",
      "INBOX_NAME": "Názov schránky",
      "TEAM_NAME": "Názov tímu",
      "CONVERSATION_IDENTIFIER": "Identifikátor konverzácie",
      "CAMPAIGN_NAME": "Názov kampane",
      "LABELS": "Štítky",
      "BROWSER_LANGUAGE": "Jazyk prehliadača",
      "PRIORITY": "Priorita",
      "COUNTRY_NAME": "Názov krajiny",
      "REFERER_LINK": "Odkazujúci odkaz",
      "CUSTOM_ATTRIBUTE_LIST": "Zoznam",
      "CUSTOM_ATTRIBUTE_TEXT": "Text",
      "CUSTOM_ATTRIBUTE_NUMBER": "Číslo",
      "CUSTOM_ATTRIBUTE_LINK": "Odkaz",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Zaškrtávacie pole",
      "CREATED_AT": "Vytvorené",
      "LAST_ACTIVITY": "Posledná aktivita",
      "LAST_CUSTOMER_MESSAGE_AT": "Posledný správa od zákazníka",
      "PHONE_CALL": "Telefónne hovor",
      "RATING": "Hodnotenie",
      "CSAT": "CSAT"
    },
    "PHONE_CALL_TYPES": {
      "INBOUND": "Prichádzajúci",
      "OUTBOUND": "Odchádzajúci",
      "MISSED": "Zmeškaný",
      "UNHANDLED_MISSED": "Neobsloužený zmeškaný"
    },
    "RATING_TYPES": {
      "UP": "Palec hore",
      "DOWN": "Palec dole"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Hodnota je povinná",
      "ATTRIBUTE_KEY_REQUIRED": "Kľúč atribútu je povinný",
      "FILTER_OPERATOR_REQUIRED": "Operátor filtra je povinný",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Hodnota musí byť medzi 0 a 998",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Štandardné filtre",
      "ADDITIONAL_FILTERS": "Ďalšie filtre",
      "CUSTOM_ATTRIBUTES": "Vlastné atribúty"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Chcete uložiť tento filter?",
        "LABEL": "Pomenujte tento filter",
        "PLACEHOLDER": "Pomenujte svoj filter, aby ste ho neskôr mohli použiť.",
        "ERROR_MESSAGE": "Názov je povinný.",
        "SAVE_BUTTON": "Uložiť filter",
        "CANCEL_BUTTON": "Zrušiť",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Zložka bola úspešne vytvorená.",
          "ERROR_MESSAGE": "Chyba pri vytváraní zložky."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment bol úspešne vytvorený.",
          "ERROR_MESSAGE": "Chyba pri vytváraní segmentu."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Upraviť zložku",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Chyba pri úprave zložky."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Odstrániť filter",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Potvrdiť odstránenie",
            "MESSAGE": "Naozaj chcete odstrániť filter ",
            "YES": "Áno, odstrániť",
            "NO": "Nie, ponechať"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Zložka bola úspešne odstránená.",
          "ERROR_MESSAGE": "Chyba pri odstraňovaní zložky."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment bol úspešne odstránený.",
          "ERROR_MESSAGE": "Chyba pri odstraňovaní segmentu."
        }
      }
    }
  }
}
